import { svg } from "lit";
const icon = svg `<path d="M5 40.6345V38.3653H42.9999V40.6345H5ZM7 34.8653V23H11.2692V34.8653H7ZM16.8769 34.8653V13H21.1461V34.8653H16.8769ZM26.8038 34.8653V19H31.073V34.8653H26.8038ZM36.7307 34.8653V7H40.9999V34.8653H36.7307Z" fill="currentColor"/>`;
export default icon;
